import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/main.css';
import { App } from './view/Main';
import { DATA } from './game/data';
import { StartPopulationIncreaseManager } from './game/populationIncreaseEventManager';
import { CrazySDK } from './crazySDK';
import { runBalance } from './balance/balance';
import { checkManyMoney } from './game/helpers';

function start() {
  CrazySDK.init().then(() => {
    DATA.load();

    if (window.location.href.includes('balance_logs=true')) {
      runBalance();
    }

    StartPopulationIncreaseManager();
    checkManyMoney();

    setInterval(() => {
      DATA.save();
    }, 5000);

    const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );

    CrazySDK.game.gameplayStart();

    setTimeout(() => {
      document.querySelector('#loading-screen')?.remove();
    }, 100);
  });
}

export const ZOOM_WIDTH = 940;
export const ZOOM_FACTOR = 0.8;

function adjustZoom() {
  const screenWidth = window.innerWidth;
  if (screenWidth < ZOOM_WIDTH) {
    (document as any).body.style.zoom = `${ZOOM_FACTOR}`;
  } else {
    (document as any).body.style.zoom = '1';
  }
}
adjustZoom();
window.addEventListener('resize', adjustZoom);

start();
